// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

import React from "react";

function tr(key, fallback) {
  try {
    const translator = window?.__ARCHAT_I18N__?.t;
    if (typeof translator === 'function') {
      const value = translator(key);
      if (value && value !== key) return value;
    }
  } catch {
    // noop
  }
  return fallback;
}

export default class ReactSafeBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("[ARCHAT][REACT_BOUNDARY]", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            padding: "20px",
            textAlign: "center",
            color: "var(--color-text-primary)",
          }}
        >
          {tr('errors.ui_boundary.refresh', 'ArChat UI error — refresh the page')}
        </div>
      );
    }
    return this.props.children;
  }
}
